// Event Status
export const EVENT_STATUS = {
  INACTIVE: "0",
  ACTIVE: "1"
} as const;

// Event Free Status
export const EVENT_FREE_STATUS = {
  UNKNOWN: "0",
  ALL_FREE: "1",
  ALL_PAID: "2",
  MIXED: "3"
} as const;

// Online/Offline
export const EVENT_LOCATION_TYPE = {
  OFFLINE: "0",
  ONLINE: "1"
} as const;

// Ticket Status
export const TICKET_STATUS = {
  AVAILABLE: "available",
  RUNNING_OUT: "running_out",
  SOLD_OUT: "sold_out"
} as const;

// Location Filters
export const LOCATION_FILTERS = {
  ISTANBUL: 'istanbul',
  ONLINE: 'online'
} as const;

// Sponsor Types
export const SPONSOR_TYPES = {
  MAIN: "Ana Sponsor",
  PLATINUM: "Platin Sponsor",
  GOLD: "Altın Sponsor"
} as const;

// Default values
export const DEFAULT_PAGE_SIZE = 20;
// Note: DEFAULT_EVENT_IMAGE and DEFAULT_CHANNEL_LOGO are no longer used.
// Use GrayBanner component for event banners and ChannelInitialIcon for channel logos.

// Highlight images for hero section
export const HERO_IMAGES = [
  '/highlight-images/1.webp',
  '/highlight-images/2.webp'
];

